import React, { useCallback } from "react";
import { IndexFiltersMode, useSetIndexFiltersMode } from "@shopify/polaris";
import type { ChoiceListProps, IndexFiltersProps } from "@shopify/polaris";
import TableFilters from "./TableFilters";

export default function TableControls({
  choices,
  selected,
  onChange,
  sortOptions,
  sortSelected,
  onSort,
}: {
  readonly choices: ChoiceListProps["choices"];
  readonly selected: string[];
  readonly onChange: (selected: string[]) => void;
} & Pick<IndexFiltersProps, "sortOptions" | "sortSelected" | "onSort">): React.JSX.Element {
  const { mode, setMode } = useSetIndexFiltersMode();
  const handleClose = useCallback((): void => {
    setMode(IndexFiltersMode.Default);
  }, [setMode]);

  return (
    <TableFilters
      canCreateNewView={false}
      columnSelection={{ choices, selected, onChange }}
      disableKeyboardShortcuts
      disableStickyMode
      filters={[]}
      hideFilters
      hideQueryField
      mode={mode}
      onClearAll={handleClose}
      onQueryChange={handleClose}
      onQueryClear={handleClose}
      onSort={onSort}
      selected={0}
      setMode={setMode}
      sortOptions={sortOptions}
      sortSelected={sortSelected}
      tabs={[]}
    />
  );
}
